import moment from 'moment-timezone';

import { getMonthsBetween } from '../../VisitsScheduling/calendar/utils';
import { Episode } from './types';

/**
 * Get the end date for an episode, calculating it if not provided
 * Episodes 1-2 are 90 days, others are 60 days
 */
export const getEpisodeEndDate = (
    episode: Pick<Episode, 'startDate' | 'endDate' | 'numberInSequence'>,
) => {
    let episodeLength = 60;
    if (episode.numberInSequence && episode.numberInSequence <= 2) {
        episodeLength = 90;
    }
    return episode.endDate ?? moment(episode.startDate).add(episodeLength, 'days').toDate();
};

// The date span the calendar should cover for an episode: its own window widened
// to include any visits dated outside it (visitEffectiveDateWindow). A visit can
// belong to an episode yet fall outside its start/end, so bounding by the window
// alone drops those visits.
export const getEpisodeCalendarRange = (
    episode: Pick<
        Episode,
        'startDate' | 'endDate' | 'numberInSequence' | 'visitEffectiveDateWindow'
    >,
): { start: Date; end: Date } | null => {
    if (!episode.startDate) {
        return null;
    }
    let start = moment(episode.startDate);
    let end = moment(getEpisodeEndDate(episode));
    const window = episode.visitEffectiveDateWindow;
    if (window) {
        start = moment.min(start, moment(window.startDate));
        end = moment.max(end, moment(window.endDate));
    }
    return { start: start.toDate(), end: end.toDate() };
};

export const getMonthsInRange = (episode: Episode): Date[] => {
    const range = getEpisodeCalendarRange(episode);
    if (!range) {
        return [new Date()];
    }
    return getMonthsBetween(range.start, range.end);
};
